import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Alert, Button } from 'reactstrap';
import Page from '../../../../components/Page';
import Steps from '../../../../components/Generales/Steps';
import LoadingScreen from 'react-loading-screen';
import logo from 'assets/img/logo/logo_aig_login-2.png';

// Acciones Redux y API
import { 
    obtenerCotizacionMoto, 
    guardarCotizacionMotoPaso1, 
    limpiarDatosCotizacion 
} from '../../redux/aMotos';
import { httpClient } from '../../../../api/httpClient';
import { urlObtenerPdfCotizacionMoto } from '../../api/urls';
import { ambienteAplicacion } from '../../../../constants/urls';

// Componentes del Módulo
import DatosVehiculoMoto from '../../components/DatosVehiculoMoto';
import DatosComplementariosMoto from '../../components/DatosComplementariosMoto';
import DatosAseguradoMoto from '../../components/DatosAseguradoMoto';
import DatosConductorMoto from '../../components/DatosConductorMoto';
import ValoresCotizacionMoto from '../../components/ValoresCotizacionMoto';

/**
 * Valida que la edad calculada a partir de una fecha de nacimiento (YYYY-MM-DD)
 * se encuentre en el rango permitido de 18 a 70 años.
 */
var validarEdad = function(fechaStr) {
    if (!fechaStr) {
        return { valido: false, msg: 'La fecha de nacimiento es requerida.' };
    }
    var fechaNac = new Date(fechaStr);
    if (isNaN(fechaNac.getTime())) {
        return { valido: false, msg: 'Formato de fecha inválido.' };
    }
    var hoy = new Date();
    var edad = hoy.getFullYear() - fechaNac.getFullYear();
    var mes = hoy.getMonth() - fechaNac.getMonth();
    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
        edad--;
    }
    if (edad < 18) {
        return { valido: false, msg: 'El asegurado debe ser mayor de edad (mínimo 18 años).' };
    }
    if (edad > 70) {
        return { valido: false, msg: 'La edad máxima permitida es de 70 años.' };
    }
    return { valido: true, edad: edad };
};

/**
 * Paso 2: Datos de Emisión de la Cotización de Motos.
 */
const EmisionMoto = ({
    history,
    location,
    obtenerCotizacionMoto,
    guardarCotizacionMotoPaso1,
    limpiarDatosCotizacion,
    estadoMotos,
    datosUsuarios,
    datosSucursales,
    sucursales
}) => {
    const [cargando, setCargando] = useState(true);
    const [actualizando, setActualizando] = useState(false);
    const [huboCambio, setHuboCambio] = useState(false);
    const [pdfUrl, setPdfUrl] = useState('');
    
    // Datos Vehículo y Accesorios
    const [poseeAccesorios, setPoseeAccesorios] = useState(false);
    const [valorExtras, setValorExtras] = useState('');
    const [accesoriosSeleccionados, setAccesoriosSeleccionados] = useState([]);
    const [amparoPatrimonial, setAmparoPatrimonial] = useState(false);
    
    // Datos Complementarios Vehículo
    const [placa, setPlaca] = useState('');
    const [motor, setMotor] = useState('');
    const [chasis, setChasis] = useState('');
    const [color, setColor] = useState(null);
    const [valorAsegurado, setValorAsegurado] = useState('');
    const [polizaAutoVigente, setPolizaAutoVigente] = useState('');

    // Datos Asegurado
    const [datosAsegurado, setDatosAsegurado] = useState({
        tipoDocumento: { value: '1', label: 'Cédula de Identidad' },
        identificacion: '',
        nombres: '',
        fechaNacimiento: '',
        genero: null,
        estadoCivil: null,
        celular: '',
        correo: '',
        direccion: ''
    });

    // Datos Conductor
    const [mismosDatosAsegurado, setMismosDatosAsegurado] = useState(true);
    const [datosConductor, setDatosConductor] = useState({
        tipoDocumento: { value: '1', label: 'Cédula de Identidad' },
        identificacion: '',
        nombres: '',
        fechaNacimiento: '',
        genero: null,
        parentesco: null,
        estadoCivil: null
    });

    const [checkDeclaracionConductor, setCheckDeclaracionConductor] = useState(false);
    const [textoDeclaracionConductor, setTextoDeclaracionConductor] = useState('');
    const [erroresValidacion, setErroresValidacion] = useState({});

    const listaOpciones = [
        { id: 0, label: 'Cotización', value: 'cotizacion' },
        { id: 1, label: 'Resumen', value: 'resumen' },
        { id: 2, label: 'Confirmación', value: 'confirmacion' },
        { id: 3, label: 'Forma de Pago', value: 'forma-pago' },
        { id: 4, label: 'Formulario de Vinculación', value: 'formulario-vinculacion' },
        { id: 5, label: 'Emisión', value: 'emision' }
    ];

    // Obtener idCarrito de los query params
    var searchStr = (location && location.search) || (window.location && window.location.search) || '';
    var queryParams = new URLSearchParams(searchStr);
    var idCarrito = queryParams.get('idCarrito') || queryParams.get('id');

    useEffect(() => {
        var cargarInformacion = async () => {
            if (idCarrito) {
                setCargando(true);
                limpiarDatosCotizacion();
                var res = await obtenerCotizacionMoto(idCarrito);
                // Consultar PDF inicial antes de quitar la pantalla de carga
                try {
                    var resPdf = await httpClient.get(urlObtenerPdfCotizacionMoto + idCarrito);
                    if (resPdf && resPdf.transaccion && resPdf.url) {
                        setPdfUrl(resPdf.url);
                    }
                } catch (errPdf) {
                    console.error('Error al obtener PDF inicial:', errPdf);
                }

                setCargando(false);
                if (res && res.exito && res.data) {
                    var textoDecl = res.data.textoDeclaracionConductor || 
                                    (res.data.carrito && res.data.carrito.textoDeclaracionConductor) || 
                                    (estadoMotos && estadoMotos.textoDeclaracionConductor) || '';
                    if (textoDecl) {
                        setTextoDeclaracionConductor(textoDecl);
                    }

                    var v = res.data.datosVehiculo || {};
                    var tieneExt = (v.poseeExtras === 'si') || (parseFloat(v.valorExtras) > 0);
                    setPoseeAccesorios(tieneExt);
                    setValorExtras(v.valorExtras ? String(v.valorExtras) : '');
                    setAmparoPatrimonial(Boolean(v.amparoPatrimonial));
                    
                    var accs = [];
                    if (Array.isArray(v.accesorios)) {
                        accs = v.accesorios.map(function(item) {
                            if (typeof item === 'object' && item !== null) {
                                return {
                                    value: item.value || item.accCodigoCore || item.codigo || '',
                                    label: item.label || item.accNombre || item.nombre || (item.value || '')
                                };
                            }
                            return {
                                value: item,
                                label: item
                            };
                        });
                    }
                    setAccesoriosSeleccionados(accs);

                    // Cargar respaldo desde localStorage si existe
                    var backupLocal = null;
                    try {
                        var rawB = localStorage.getItem('motos_datos_consulta_' + idCarrito);
                        if (rawB) backupLocal = JSON.parse(rawB);
                    } catch (e) {}

                    var backupConsulta = (backupLocal && backupLocal.datosConsulta) || {};
                    var backupAsegurado = (backupLocal && backupLocal.datosAsegurado) || {};

                    // Precargar datos complementarios
                    setPlaca(v.placa || backupConsulta.placa || '');
                    setMotor(v.motor || backupConsulta.motor || '');
                    setChasis(v.chasis || backupConsulta.chasis || '');
                    if (v.color || v.colorNombre) {
                        setColor({
                            value: v.color || v.colorNombre,
                            label: v.colorNombre || v.color
                        });
                    }
                    setValorAsegurado(v.valorAsegurado || backupConsulta.valorAsegurado || '');
                    setPolizaAutoVigente(v.polizaAutoVigente || '');

                    // Precargar Asegurado
                    var da = res.data.datosAsegurado || (res.data.carrito && res.data.carrito.datosAsegurado) || backupAsegurado || null;

                    var rawTipoDoc = (da && da.tipoDocumento) || { value: '1', label: 'Cédula de Identidad' };
                    var tipoDoc = rawTipoDoc;
                    if (typeof rawTipoDoc === 'object' && rawTipoDoc !== null) {
                        if (rawTipoDoc.value === 'CEDULA') tipoDoc = { value: '1', label: 'Cédula de Identidad' };
                        else if (rawTipoDoc.value === 'RUC') tipoDoc = { value: '2', label: 'RUC' };
                        else if (rawTipoDoc.value === 'PASAPORTE') tipoDoc = { value: '3', label: 'Pasaporte' };
                    } else if (typeof rawTipoDoc === 'string') {
                        if (rawTipoDoc === 'CEDULA' || rawTipoDoc === '1') tipoDoc = { value: '1', label: 'Cédula de Identidad' };
                        else if (rawTipoDoc === 'RUC' || rawTipoDoc === '2') tipoDoc = { value: '2', label: 'RUC' };
                        else if (rawTipoDoc === 'PASAPORTE' || rawTipoDoc === '3') tipoDoc = { value: '3', label: 'Pasaporte' };
                    }
                    var ident = (da && da.identificacion) || backupConsulta.cedula_propietario || '';
                    var nom = (da && da.nombres) || backupConsulta.nombre_propietario || '';

                    // Fecha nacimiento
                    var fn = (da && da.fechaNacimiento) || backupConsulta.fecha_nacimiento_propietario || '';
                    if (fn && fn.indexOf('/') !== -1) {
                        var partsFn = fn.split('/');
                        if (partsFn.length === 3) {
                            fn = partsFn[2] + '-' + (partsFn[1].length === 1 ? '0' + partsFn[1] : partsFn[1]) + '-' + (partsFn[0].length === 1 ? '0' + partsFn[0] : partsFn[0]);
                        }
                    }

                    // Género
                    var gen = (da && da.genero) || null;
                    var genValStr = '';
                    if (gen) {
                        genValStr = typeof gen === 'object' && gen !== null ? (gen.value || '') : String(gen);
                    } else if (backupConsulta.genero_propietario) {
                        genValStr = String(backupConsulta.genero_propietario);
                    }
                    if (genValStr) {
                        var esMas = (genValStr.toUpperCase().indexOf('M') === 0 || genValStr === '1');
                        gen = { value: esMas ? '1' : '2', label: esMas ? 'Masculino' : 'Femenino' };
                    }

                    // Estado Civil
                    var ec = (da && da.estadoCivil) || null;
                    var ecValStr = '';
                    if (ec) {
                        ecValStr = typeof ec === 'object' && ec !== null ? (ec.value || '') : String(ec);
                    } else if (backupConsulta.estado_civil_propietario) {
                        ecValStr = String(backupConsulta.estado_civil_propietario);
                    }
                    if (ecValStr) {
                        var ecUpper = ecValStr.toUpperCase();
                        var ecCod = '1';
                        var matchLabel = 'Soltero(a)';
                        if (ecUpper.indexOf('CASAD') !== -1 || ecUpper === '2') {
                            ecCod = '2';
                            matchLabel = 'Casado(a)';
                        } else if (ecUpper.indexOf('DIVOR') !== -1 || ecUpper === '4') {
                            ecCod = '4';
                            matchLabel = 'Divorciado(a)';
                        } else if (ecUpper.indexOf('UNION') !== -1 || ecUpper.indexOf('LIBRE') !== -1 || ecUpper === '3') {
                            ecCod = '3';
                            matchLabel = 'Unión Libre';
                        } else if (ecUpper.indexOf('VIUD') !== -1 || ecUpper === '5') {
                            ecCod = '5';
                            matchLabel = 'Viudo(a)';
                        } else if (ecUpper.indexOf('SOLT') !== -1 || ecUpper === '1') {
                            ecCod = '1';
                            matchLabel = 'Soltero(a)';
                        }
                        ec = { value: ecCod, label: matchLabel };
                    }

                    setDatosAsegurado({
                        tipoDocumento: tipoDoc,
                        identificacion: ident,
                        nombres: nom,
                        fechaNacimiento: fn,
                        genero: gen,
                        estadoCivil: ec,
                        celular: (da && da.celular) || '',
                        correo: (da && da.correo) || '',
                        direccion: (da && da.direccion) || '',
                        ciudad: (da && da.ciudad) || v.ciudadNombre || (v.ciudad && v.ciudad.label) || '',
                        codCiudad: (da && da.codCiudad) || v.codCiudad || v.ciudad || '',
                        provincia: (da && da.provincia) || v.provinciaNombre || (v.provincia && v.provincia.label) || '',
                        codProvincia: (da && da.codProvincia) || v.codProvincia || v.provincia || ''
                    });

                    // Precargar Conductor
                    var dc = res.data.datosConductor || (res.data.carrito && res.data.carrito.datosConductor) || null;
                    if (dc) {
                        var rawDcTipoDoc = dc.tipoDocumento || { value: '1', label: 'Cédula de Identidad' };
                        var dcTipoDoc = rawDcTipoDoc;
                        if (typeof rawDcTipoDoc === 'object' && rawDcTipoDoc !== null) {
                            if (rawDcTipoDoc.value === 'CEDULA') dcTipoDoc = { value: '1', label: 'Cédula de Identidad' };
                            else if (rawDcTipoDoc.value === 'PASAPORTE') dcTipoDoc = { value: '3', label: 'Pasaporte' };
                        }

                        // Género
                        var condGen = dc.genero || null;
                        var condGenVal = dc.codGenero || (typeof condGen === 'object' && condGen !== null ? condGen.value : String(condGen || ''));
                        var condGenNom = (typeof condGen === 'object' && condGen !== null ? condGen.label : String(condGen || ''));
                        if (condGenVal || condGenNom) {
                            var esMasC = (String(condGenVal).toUpperCase().indexOf('M') === 0 || condGenVal === '1' || String(condGenNom).toUpperCase() === 'MASCULINO');
                            condGen = { value: esMasC ? '1' : '2', label: esMasC ? 'Masculino' : 'Femenino' };
                        }

                        // Parentesco
                        var condPar = dc.parentesco || null;
                        var condParVal = dc.codParentesco !== undefined ? String(dc.codParentesco) : (typeof condPar === 'object' && condPar !== null ? condPar.value : String(condPar || ''));
                        var condParNom = (typeof condPar === 'object' && condPar !== null ? condPar.label : String(condPar || ''));
                        if (condParVal || condParNom) {
                            condPar = { value: condParVal || condParNom, label: condParNom || condParVal };
                        }

                        // Estado Civil
                        var condEc = dc.estadoCivil || null;
                        var condEcVal = dc.codEstadoCivil || (typeof condEc === 'object' && condEc !== null ? condEc.value : String(condEc || ''));
                        var condEcNom = (typeof condEc === 'object' && condEc !== null ? condEc.label : String(condEc || ''));
                        if (condEcVal || condEcNom) {
                            var ecValC = String(condEcVal || condEcNom).toUpperCase();
                            var ecCodC = '1';
                            var matchLabelC = 'Soltero(a)';
                            if (ecValC.indexOf('CASAD') !== -1 || ecValC === '2') {
                                ecCodC = '2';
                                matchLabelC = 'Casado(a)';
                            } else if (ecValC.indexOf('DIVOR') !== -1 || ecValC === '4') {
                                ecCodC = '4';
                                matchLabelC = 'Divorciado(a)';
                            } else if (ecValC.indexOf('UNION') !== -1 || ecValC.indexOf('LIBRE') !== -1 || ecValC === '3') {
                                ecCodC = '3';
                                matchLabelC = 'Unión Libre';
                            } else if (ecValC.indexOf('VIUD') !== -1 || ecValC === '5') {
                                ecCodC = '5';
                                matchLabelC = 'Viudo(a)';
                            } else if (ecValC.indexOf('SOLT') !== -1 || ecValC === '1') {
                                ecCodC = '1';
                                matchLabelC = 'Soltero(a)';
                            }
                            condEc = { value: ecCodC, label: matchLabelC };
                        }

                        setMismosDatosAsegurado(Boolean(dc.mismosDatosAsegurado !== false));
                        setDatosConductor({
                            tipoDocumento: dcTipoDoc,
                            identificacion: dc.identificacion || '',
                            nombres: dc.nombres || '',
                            fechaNacimiento: dc.fechaNacimiento || '',
                            genero: condGen,
                            parentesco: condPar,
                            estadoCivil: condEc,
                            ciudad: (dc && dc.ciudad) || v.ciudadNombre || (v.ciudad && v.ciudad.label) || '',
                            codCiudad: (dc && dc.codCiudad) || v.codCiudad || v.ciudad || '',
                            provincia: (dc && dc.provincia) || v.provinciaNombre || (v.provincia && v.provincia.label) || '',
                            codProvincia: (dc && dc.codProvincia) || v.codProvincia || v.provincia || ''
                        });
                        if (dc.declaracionConductor) {
                            setCheckDeclaracionConductor(Boolean(dc.declaracionConductor));
                        }
                    }

                    setHuboCambio(false);
                    setErroresValidacion({});
                }
            } else {
                setCargando(false);
            }
        };
        cargarInformacion();
    }, [idCarrito]);

    const isGlobalLoading = cargando || actualizando || (estadoMotos && estadoMotos.isLoading);

    var datosVehiculo = (estadoMotos && estadoMotos.datosVehiculo) || (estadoMotos && estadoMotos.cotizacion && estadoMotos.cotizacion.datosVehiculo) || {};
    var plan = estadoMotos && estadoMotos.plan;
    var valorTot = (estadoMotos && (estadoMotos.valorTotal || (estadoMotos.carrito && estadoMotos.carrito.valorTotal))) || null;

    var esPlanSafe = Boolean(
        (plan && (plan.codigo === '56' || (plan.nombre && plan.nombre.toUpperCase().indexOf('SAFE') !== -1))) ||
        (datosVehiculo && parseFloat(datosVehiculo.valorAsegurado) <= 6999)
    );

    var handleModificar = function() {
        if (history) {
            var currentId = idCarrito || (estadoMotos && estadoMotos.idCarrito);
            history.push('/motos/cotizar' + (currentId ? ('?idCarrito=' + currentId) : ''));
        }
    };

    // Handlers de Accesorios
    var handleChangePoseeAccesorios = function(e) {
        var val = (e && e.target !== undefined) ? Boolean(e.target.checked) : Boolean(e);
        setPoseeAccesorios(val);
        if (!val) {
            setValorExtras('');
            setAccesoriosSeleccionados([]);
        }
        setHuboCambio(true);
    };

    var handleChangeValorExtras = function(e) {
        var val = (e && e.target !== undefined) ? e.target.value : e;
        setValorExtras(val);
        setHuboCambio(true);
    };

    var handleChangeAccesoriosSeleccionados = function(val) {
        setAccesoriosSeleccionados(val || []);
        setHuboCambio(true);
    };

    var handleChangeAmparoPatrimonial = function(val) {
        setAmparoPatrimonial(val);
        setHuboCambio(true);
    };

    // Handlers de Datos Complementarios
    var handleChangePlaca = function(val) {
        setPlaca(val);
        setHuboCambio(true);
    };

    var handleChangeMotor = function(val) {
        setMotor(val);
        setHuboCambio(true);
    };

    var handleChangeChasis = function(val) {
        setChasis(val);
        setHuboCambio(true);
    };

    var handleChangeColor = function(val) {
        setColor(val);
        setHuboCambio(true);
    };

    var handleChangeValorAsegurado = function(val) {
        setValorAsegurado(val);
        setHuboCambio(true);
    };


    var handleChangePolizaAutoVigente = function(val) {
        setPolizaAutoVigente(val);
        setHuboCambio(true);
    };

    // Handlers de Asegurado
    var handleChangeCampoAsegurado = function(campo, val) {
        setDatosAsegurado(function(prev) {
            var upd = Object.assign({}, prev);
            upd[campo] = val;
            return upd;
        });
        setHuboCambio(true);
    };

    // Handlers de Conductor
    var handleChangeMismosDatosAsegurado = function(val) {
        setMismosDatosAsegurado(val);
        setHuboCambio(true);
    };

    var handleChangeCampoConductor = function(campo, val) {
        setDatosConductor(function(prev) {
            var upd = Object.assign({}, prev);
            upd[campo] = val;
            return upd;
        });
        setHuboCambio(true);
    };

    // Validación Completa para Emisión
    var ejecutarValidacionesEmision = function() {
        var errs = {
            accesorios: {},
            complementarios: {},
            asegurado: {},
            conductor: {}
        };
        var tieneError = false;

        // 1. Validar Accesorios
        if (poseeAccesorios) {
            var sinAccesorios = !accesoriosSeleccionados || accesoriosSeleccionados.length === 0;
            var numExtras = parseFloat(valorExtras);
            var sinValor = !valorExtras || isNaN(numExtras) || numExtras <= 0;
            var numValorCasco = parseFloat(datosVehiculo.valorAsegurado) || 0;
            var maxPermitido = (numValorCasco * 20) / 100;
            var superaLimite = numExtras > maxPermitido;

            if (sinAccesorios || sinValor || superaLimite) {
                errs.accesorios = {
                    sinAccesorios: sinAccesorios,
                    sinValor: sinValor,
                    superaLimite: superaLimite
                };
                tieneError = true;
            }
        }

        // 2. Validar Datos Complementarios del Vehículo
        var placaTrim = (placa || '').trim().toUpperCase();
        if (!placaTrim || placaTrim === 'SIN PLACA' || placaTrim === 'SINPLACA' || placaTrim.length < 5) {
            errs.complementarios.placa = true;
            errs.complementarios.placaMsg = "Para continuar es obligatorio registrar una placa válida.";
            tieneError = true;
        }
        if (!color || !color.value) {
            errs.complementarios.color = true;
            tieneError = true;
        }

        var sinValorAsegurado = !valorAsegurado || isNaN(valorAsegurado) || valorAsegurado <= 0 || valorAsegurado.length === 0;
        if(sinValorAsegurado){
            errs.complementarios.sinValorAsegurado = true;
            tieneError = true;
        }

        var valorAseguradoSuperaLimite = valorAsegurado > 100000; 
        if (valorAseguradoSuperaLimite) {
            errs.complementarios.valorAseguradoSuperaLimite = true;
            tieneError = true;
        }
        
        if (esPlanSafe && (!polizaAutoVigente || polizaAutoVigente.trim().length === 0)) {
            errs.complementarios.polizaAuto = true;
            tieneError = true;
        }

        // 3. Validar Asegurado
        if (!datosAsegurado.identificacion || datosAsegurado.identificacion.trim().length < 10) {
            errs.asegurado.identificacion = true;
            tieneError = true;
        }
        if (!datosAsegurado.nombres || datosAsegurado.nombres.trim().length < 3) {
            errs.asegurado.nombres = true;
            tieneError = true;
        }
        var resEdad = validarEdad(datosAsegurado.fechaNacimiento);
        if (!resEdad.valido) {
            errs.asegurado.fechaNacimiento = true;
            errs.asegurado.fechaNacimientoMsg = resEdad.msg;
            tieneError = true;
        }
        if (!datosAsegurado.genero || !datosAsegurado.genero.value) {
            errs.asegurado.genero = true;
            tieneError = true;
        }
        if (!datosAsegurado.estadoCivil || !datosAsegurado.estadoCivil.value) {
            errs.asegurado.estadoCivil = true;
            tieneError = true;
        }
        if (!datosAsegurado.celular || datosAsegurado.celular.trim().length < 9) {
            errs.asegurado.celular = true;
            tieneError = true;
        }
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!datosAsegurado.correo || !emailRegex.test(datosAsegurado.correo.trim())) {
            errs.asegurado.correo = true;
            tieneError = true;
        }
        if (!datosAsegurado.direccion || datosAsegurado.direccion.trim().length < 5) {
            errs.asegurado.direccion = true;
            tieneError = true;
        }

        // 4. Validar Conductor
        if (!mismosDatosAsegurado) {
            if (!datosConductor.identificacion || datosConductor.identificacion.trim().length < 10) {
                errs.conductor.identificacion = true;
                tieneError = true;
            }
            if (!datosConductor.nombres || datosConductor.nombres.trim().length < 3) {
                errs.conductor.nombres = true;
                tieneError = true;
            }
            var resEdadCond = validarEdad(datosConductor.fechaNacimiento);
            if (!resEdadCond.valido) {
                errs.conductor.fechaNacimiento = true;
                errs.conductor.fechaNacimientoMsg = resEdadCond.msg;
                tieneError = true;
            }
            if (!datosConductor.genero || !datosConductor.genero.value) {
                errs.conductor.genero = true;
                tieneError = true;
            }
            if (!datosConductor.parentesco || !datosConductor.parentesco.value) {
                errs.conductor.parentesco = true;
                tieneError = true;
            }
            if (!datosConductor.estadoCivil || !datosConductor.estadoCivil.value) {
                errs.conductor.estadoCivil = true;
                tieneError = true;
            }
        }

        // 5. Validar Check Obligatorio de Declaración del Conductor
        if (!checkDeclaracionConductor) {
            errs.conductor.declaracionConductor = true;
            tieneError = true;
        }

        return {
            valido: !tieneError,
            errores: errs
        };
    };

    // Actualizar Cotización (Persiste y recalcula)
    var handleActualizar = async function() {
        if (!checkDeclaracionConductor) {
            setErroresValidacion(function(prev) {
                var prevCond = (prev && prev.conductor) || {};
                return Object.assign({}, prev, {
                    conductor: Object.assign({}, prevCond, { declaracionConductor: true })
                });
            });
            return;
        }

        if (poseeAccesorios) {
            var sinAccesorios = !accesoriosSeleccionados || accesoriosSeleccionados.length === 0;
            var numExtras = parseFloat(valorExtras);
            var sinValor = !valorExtras || isNaN(numExtras) || numExtras <= 0;
            var numValorCasco = parseFloat(datosVehiculo.valorAsegurado) || 0;
            var maxPermitido = (numValorCasco * 20) / 100;
            var superaLimite = numExtras > maxPermitido;

            if (sinAccesorios || sinValor || superaLimite) {
                setErroresValidacion({
                    accesorios: {
                        sinAccesorios: sinAccesorios,
                        sinValor: sinValor,
                        superaLimite: superaLimite
                    }
                });
                return;
            }
        }

         var sinValorAsegurado = !valorAsegurado || isNaN(valorAsegurado) || valorAsegurado.length === 0;
         var valorAseguradoSuperaLimite = valorAsegurado > 100000; 
         var valorAseguradoMenorPermitido = !valorAsegurado || isNaN(valorAsegurado) || valorAsegurado < 1000;
        if (sinValorAsegurado || valorAseguradoSuperaLimite || valorAseguradoMenorPermitido) {
                setErroresValidacion({
                    complementarios: {
                        sinValorAsegurado: sinValorAsegurado,
                        valorAseguradoSuperaLimite: valorAseguradoSuperaLimite,
                        valorAseguradoMenorPermitido:valorAseguradoMenorPermitido
                    }
                });
                return;
        }
        setActualizando(true);
        setErroresValidacion({});
        var currentId = idCarrito || (estadoMotos && estadoMotos.idCarrito);
        
        var provVal = datosVehiculo.codProvincia || datosVehiculo.provincia || '';
        var provNom = datosVehiculo.provinciaNombre || (datosVehiculo.provincia && datosVehiculo.provincia.label) || '';
        var ciudadVal = datosVehiculo.codCiudad || datosVehiculo.ciudad || '';
        var ciudadNom = datosVehiculo.ciudadNombre || (datosVehiculo.ciudad && datosVehiculo.ciudad.label) || '';
        var sucVal = datosVehiculo.sucursal || '';
        var sucNom = datosVehiculo.sucursalNombre || (datosVehiculo.sucursal && datosVehiculo.sucursal.label) || '';

        var condGeneroObj = null;
        var condParentescoObj = null;
        var condEstadoCivilObj = null;

        if (mismosDatosAsegurado) {
            condGeneroObj = datosAsegurado.genero;
            condParentescoObj = { value: '0', label: 'TITULAR' };
            condEstadoCivilObj = datosAsegurado.estadoCivil;
        } else {
            condGeneroObj = datosConductor.genero;
            condParentescoObj = datosConductor.parentesco;
            condEstadoCivilObj = datosConductor.estadoCivil;
        }

        var conductorFinal = {
            mismosDatosAsegurado: Boolean(mismosDatosAsegurado),
            declaracionConductor: Boolean(checkDeclaracionConductor),
            tipoDocumento: mismosDatosAsegurado ? datosAsegurado.tipoDocumento : datosConductor.tipoDocumento,
            identificacion: mismosDatosAsegurado ? datosAsegurado.identificacion : datosConductor.identificacion,
            nombres: mismosDatosAsegurado ? datosAsegurado.nombres : datosConductor.nombres,
            fechaNacimiento: mismosDatosAsegurado ? datosAsegurado.fechaNacimiento : datosConductor.fechaNacimiento,
            genero: condGeneroObj,
            parentesco: condParentescoObj,
            estadoCivil: condEstadoCivilObj,
            ciudad: ciudadNom || '',
            codCiudad: ciudadVal || '',
            provincia: provNom || '',
            codProvincia: provVal || ''
        };

        var aseguradoFinal = Object.assign({}, datosAsegurado, {
            ciudad: ciudadNom || '',
            codCiudad: ciudadVal || '',
            provincia: provNom || '',
            codProvincia: provVal || ''
        });

        var finalSucCod = sucVal || (datosSucursales && datosSucursales.sucursalSelecionadaAsesor) || "";
        var finalSucNom = sucNom || "";
        if (!finalSucNom && finalSucCod && Array.isArray(sucursales)) {
            var foundSuc = sucursales.find(function(s) { return s.sucCodigoCore == finalSucCod; });
            if (foundSuc) {
                finalSucNom = foundSuc.sucNombre;
            }
        }

        var arrayDatosAsesorObj = {
            nombre: `${(datosUsuarios && datosUsuarios.nombres) || ''} ${(datosUsuarios && datosUsuarios.apellidos) || ''}`.trim(),
            codigoCore: (datosUsuarios && datosUsuarios.cliCodigoCore) || "",
            sucursalSeleccionada: finalSucCod,
            sucursalSeleccionadaNombre: finalSucNom,
            ambiente: ambienteAplicacion,
            emailAsesor: (datosUsuarios && datosUsuarios.correo) || "",
            brokerRUC: (datosUsuarios && datosUsuarios.brokerRUC) || "",
            brokerNombre: (datosUsuarios && datosUsuarios.brokerNombre) || "",
            brokerCodigo: (datosUsuarios && datosUsuarios.brokerCodigo) || ""
        };

        var idUsuarioVal = (datosUsuarios && datosUsuarios.cliCodigoCore) ? String(datosUsuarios.cliCodigoCore) : "";

        var payload = {
            idCarrito: currentId,
            idUsuario: idUsuarioVal,
            arrayDatosAsesor: arrayDatosAsesorObj,
            datosVehiculo: {
                placa: (placa ? placa.trim().toUpperCase() : (datosVehiculo.placa || 'SIN PLACA')),
                codProvincia: provVal,
                provincia: provVal,
                provinciaNombre: provNom,
                codCiudad: ciudadVal,
                ciudad: ciudadVal,
                ciudadNombre: ciudadNom,
                sucursal: sucVal,
                sucursalNombre: sucNom,
                marca: datosVehiculo.marca || '',
                marcaNombre: datosVehiculo.marcaNombre || '',
                modelo: datosVehiculo.modelo || '',
                modeloNombre: datosVehiculo.modeloNombre || '',
                tipo: datosVehiculo.tipo || 'MOTO',
                anio: datosVehiculo.anio || '',
                motor: motor || '',
                chasis: chasis || '',
                color: (color && color.value) || '',
                colorNombre: (color && color.label) || '',
                polizaAutoVigente: polizaAutoVigente,
                valorAsegurado: valorAsegurado || 0,
                poseeExtras: poseeAccesorios ? 'si' : 'no',
                valorExtras: poseeAccesorios ? (parseFloat(valorExtras) || 0) : 0,
                accesorios: accesoriosSeleccionados,
                amparoPatrimonial: Boolean(amparoPatrimonial)
            },
            datosAsegurado: aseguradoFinal,
            datosConductor: conductorFinal
        };

        var res = await guardarCotizacionMotoPaso1(payload);
        if (res && res.exito) {
            var textoDeclRes = (res.data && res.data.textoDeclaracionConductor) || 
                               (res.data && res.data.carrito && res.data.carrito.textoDeclaracionConductor) || '';
            if (textoDeclRes) {
                setTextoDeclaracionConductor(textoDeclRes);
            }
            setHuboCambio(false);
            setErroresValidacion({});

            // Mantener el LoadingScreen activo hasta que responda la consulta del PDF
            try {
                var resPdf = await httpClient.get(urlObtenerPdfCotizacionMoto + currentId);
                if (resPdf && resPdf.transaccion && resPdf.url) {
                    setPdfUrl(resPdf.url);
                }
            } catch (errPdf) {
                console.error('Error re-consultando PDF de cotización:', errPdf);
            }
        }
        setActualizando(false);
        return res;
    };

    var handleContinuarAlResumen = async function() {
        var resultado = ejecutarValidacionesEmision();
        if (!resultado.valido) {
            setErroresValidacion(resultado.errores);
            window.scrollTo({ top: 250, behavior: 'smooth' });
            return;
        }
        setErroresValidacion({});
        
        // Guardar datos completos en MongoDB
        var res = await handleActualizar();
        if (res && res.exito) {
            var currentId = idCarrito || (estadoMotos && estadoMotos.idCarrito);
            if (history) {
                history.push('/motos/resumen' + (currentId ? ('?idCarrito=' + currentId) : ''));
            }
        }
    };

    return (
        <LoadingScreen
            loading={isGlobalLoading}
            bgColor="#f1f1f1"
            spinnerColor="#001871"
            textColor="#676767"
            logoSrc={logo}
            text={actualizando ? "Actualizando cotización de moto..." : "Cargando información..."}
        >
            <div className="cr-content container-fluid">
                <div className="container-body-spaces">
                    <Page
                        title="Completar Información - Cotizador de Motos"
                        breadcrumbs={[
                            { name: "Cotización de Motos", active: false },
                            { name: "Completar Información", active: true }
                        ]}
                    >
                        {/* Stepper Superior (3 Pasos) */}
                        <Row className="mb-3">
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <Steps 
                                    tipo={'parametrico'} 
                                    listaOpciones={listaOpciones} 
                                    paso={'cotizacion'} 
                                />
                            </Col>
                        </Row>

                        {estadoMotos && estadoMotos.error && (
                            <Row>
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    <Alert color="danger">
                                        {estadoMotos.error}
                                    </Alert>
                                </Col>
                            </Row>
                        )}

                        {!isGlobalLoading && (
                            <Row style={{ alignItems: 'flex-start' }}>
                                {/* Columna Izquierda: Tarjetas de Información */}
                                <Col lg={8} md={12} sm={12} xs={12}>
                                    {/* 1. Datos Principales y Accesorios */}
                                    <DatosVehiculoMoto 
                                        datosVehiculo={datosVehiculo}
                                        placa={placa}
                                        plan={plan}
                                        idCotizacion={(estadoMotos && estadoMotos.idCotizacion) || ''}
                                        idCarrito={idCarrito || (estadoMotos && estadoMotos.idCarrito) || ''}
                                        onModificar={handleModificar}
                                        poseeAccesorios={poseeAccesorios}
                                        onChangePoseeAccesorios={handleChangePoseeAccesorios}
                                        valorExtras={valorExtras}
                                        onChangeValorExtras={handleChangeValorExtras}
                                        accesoriosSeleccionados={accesoriosSeleccionados}
                                        onChangeAccesoriosSeleccionados={handleChangeAccesoriosSeleccionados}
                                        amparoPatrimonial={amparoPatrimonial}
                                        onChangeAmparoPatrimonial={handleChangeAmparoPatrimonial}
                                        erroresValidacion={erroresValidacion.accesorios}
                                    />

                                    {/* 2. Datos Complementarios (Placa, Motor, Chasis, Color, Póliza Auto, valorAsegurado) */}
                                    <DatosComplementariosMoto 
                                        placa={placa}
                                        onChangePlaca={handleChangePlaca}
                                        motor={motor}
                                        onChangeMotor={handleChangeMotor}
                                        chasis={chasis}
                                        onChangeChasis={handleChangeChasis}
                                        color={color}
                                        onChangeColor={handleChangeColor}
                                        valorAsegurado={valorAsegurado}
                                        onChangeValorAsegurado={handleChangeValorAsegurado}
                                        polizaAutoVigente={polizaAutoVigente}
                                        onChangePolizaAutoVigente={handleChangePolizaAutoVigente}
                                        esPlanSafe={esPlanSafe}
                                        errores={erroresValidacion.complementarios}
                                    />

                                    {/* 3. Datos del Asegurado */}
                                    <DatosAseguradoMoto 
                                        datosAsegurado={datosAsegurado}
                                        onChangeCampoAsegurado={handleChangeCampoAsegurado}
                                        errores={erroresValidacion.asegurado}
                                    />

                                    {/* 4. Datos del Conductor */}
                                    <DatosConductorMoto 
                                        mismosDatosAsegurado={mismosDatosAsegurado}
                                        onChangeMismosDatosAsegurado={handleChangeMismosDatosAsegurado}
                                        datosConductor={datosConductor}
                                        onChangeCampoConductor={handleChangeCampoConductor}
                                        checkDeclaracionConductor={checkDeclaracionConductor}
                                        onChangeCheckDeclaracion={(val) => {
                                            setCheckDeclaracionConductor(val);
                                            if (erroresValidacion.conductor && erroresValidacion.conductor.declaracionConductor) {
                                                setErroresValidacion(function(prev) {
                                                    var nuevoCond = Object.assign({}, prev.conductor);
                                                    delete nuevoCond.declaracionConductor;
                                                    return Object.assign({}, prev, { conductor: nuevoCond });
                                                });
                                            }
                                        }}
                                        textoDeclaracionConductor={textoDeclaracionConductor || (estadoMotos && estadoMotos.textoDeclaracionConductor)}
                                        errores={erroresValidacion.conductor}
                                    />

                                    {/* Botón Modificar Datos al final de la columna */}
                                    <div className="pt-2 pb-4">
                                        <Button 
                                            color="secondary" 
                                            onClick={handleModificar}
                                            style={{ display: 'inline-flex', alignItems: 'center' }}
                                        >
                                            <i className="fa fa-arrow-left mr-2"></i> Modificar Datos de la Moto
                                        </Button>
                                    </div>
                                </Col>

                                {/* Columna Derecha: Tarjeta de Valores Sticky */}
                                <Col lg={4} md={12} sm={12} xs={12} style={{ position: 'sticky', top: '20px', zIndex: 10 }}>
                                    <ValoresCotizacionMoto 
                                        valorTotal={valorTot}
                                        cotizacion={estadoMotos && estadoMotos.cotizacion}
                                        huboCambio={huboCambio}
                                        onActualizar={handleActualizar}
                                        onIniciarEmision={handleContinuarAlResumen}
                                        actualizando={actualizando}
                                        idCotizacion={(estadoMotos && estadoMotos.idCotizacion) || ''}
                                        idCarrito={idCarrito || (estadoMotos && estadoMotos.idCarrito) || ''}
                                        pdfUrlProp={pdfUrl}
                                        textoBotonEmision="CONTINUAR"
                                        deshabilitarAcciones={!checkDeclaracionConductor}
                                    />
                                </Col>
                            </Row>
                        )}
                    </Page>
                </div>
            </div>
        </LoadingScreen>
    );
};

const mapStateToProps = (state) => ({
    estadoMotos: state.dataMotos || state.motos || {},
    datosUsuarios: state.datosUsuarios ? state.datosUsuarios.dataUsuario : {},
    datosSucursales: state.datosSucursales || {},
    sucursales: state.datosSucursales ? state.datosSucursales.DataSucursales : []
});

const mapDispatchToProps = {
    obtenerCotizacionMoto,
    guardarCotizacionMotoPaso1,
    limpiarDatosCotizacion
};

export default connect(mapStateToProps, mapDispatchToProps)(EmisionMoto);
